<div class="materials-overview">
  <div class="card-header">
    <h3 class="section-title">Materialer</h3>
    <p class="section-desc">
      Administrer materialer og godkend materialanmodninger fra events.
    </p>
  </div>

  @if (errorMessage) {
  <p class="error-message">{{ errorMessage }}</p>
  }
  @if (accessDenied) {
  <p class="empty-message">
    Du har ikke adgang, eller materielmodulet er ikke aktiveret for organisationen.
  </p>
  }

  <mat-tab-group animationDuration="0ms">
    <!-- Materials tab -->
    <mat-tab label="Materialer">
      <div class="tab-content">
        <div class="toolbar">
          <button
            mat-raised-button
            color="primary"
            (click)="openCreateMaterial()"
            [disabled]="showCreateMaterial"
          >
            + Opret materiale
          </button>
          <button
            mat-raised-button
            (click)="exportPdf()"
            [disabled]="pdfLoading"
            class="export-btn"
          >
            {{
              pdfLoading ? "Henter PDF..." : "Export PDF (klar til afhentning)"
            }}
          </button>
        </div>

        @if (showCreateMaterial) {
        <div class="form-block">
          <h5>Ny materiale</h5>
          <mat-form-field appearance="outline">
            <mat-label>Navn</mat-label>
            <input
              matInput
              [(ngModel)]="createForm.name"
              placeholder="f.eks. Redningsvest"
            />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Antal</mat-label>
            <input
              matInput
              type="number"
              min="1"
              [(ngModel)]="createForm.total_quantity"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Beskrivelse (valgfri)</mat-label>
            <input matInput [(ngModel)]="createForm.description" />
          </mat-form-field>
          <div class="form-actions">
            <button mat-button (click)="cancelCreateMaterial()">
              Annuller
            </button>
            <button
              mat-raised-button
              color="primary"
              [disabled]="!createForm.name.trim() || saving"
              (click)="saveCreateMaterial()"
            >
              {{ saving ? "Gemmer..." : "Opret" }}
            </button>
          </div>
        </div>
        } @if (loadingMaterials) {
        <p class="loading-message">Henter materialer...</p>
        } @if (!loadingMaterials && materials.length) {
        <table mat-table [dataSource]="materials" class="materials-table">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Navn</th>
            <td mat-cell *matCellDef="let m">
              @if (editingMaterialId !== m.material_id) {
              {{ m.name }}
              } @if (editingMaterialId === m.material_id) {
              <mat-form-field appearance="outline" class="inline-edit">
                <input matInput [(ngModel)]="editForm.name" />
              </mat-form-field>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="total_quantity">
            <th mat-header-cell *matHeaderCellDef>Antal</th>
            <td mat-cell *matCellDef="let m">
              @if (editingMaterialId !== m.material_id) {
              {{ m.total_quantity }}
              } @if (editingMaterialId === m.material_id) {
              <mat-form-field appearance="outline" class="inline-edit">
                <input
                  matInput
                  type="number"
                  min="1"
                  [(ngModel)]="editForm.total_quantity"
                />
              </mat-form-field>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Beskrivelse</th>
            <td mat-cell *matCellDef="let m">
              @if (editingMaterialId !== m.material_id) {
              {{ m.description || "-" }}
              } @if (editingMaterialId === m.material_id) {
              <mat-form-field
                appearance="outline"
                class="inline-edit full-width"
              >
                <input
                  matInput
                  [(ngModel)]="editForm.description"
                  placeholder="Valgfri beskrivelse"
                />
              </mat-form-field>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Handlinger</th>
            <td mat-cell *matCellDef="let m">
              @if (editingMaterialId !== m.material_id) {
              <button mat-button (click)="openEditMaterial(m)">Rediger</button>
              <button mat-button class="btn-remove" (click)="deleteMaterial(m)">
                Slet
              </button>
              } @if (editingMaterialId === m.material_id) {
              <button mat-button (click)="cancelEditMaterial()">
                Annuller
              </button>
              <button
                mat-raised-button
                color="primary"
                [disabled]="saving"
                (click)="saveEditMaterial()"
              >
                Gem
              </button>
              }
            </td>
          </ng-container>
          <tr
            mat-header-row
            *matHeaderRowDef="[
              'name',
              'total_quantity',
              'description',
              'actions'
            ]"
          ></tr>
          <tr
            mat-row
            *matRowDef="
              let row;
              columns: ['name', 'total_quantity', 'description', 'actions']
            "
          ></tr>
        </table>
        } @if (!loadingMaterials && materials.length === 0) {
        <p class="empty-message">Ingen materialer oprettet endnu.</p>
        }
        @if (
          editingMaterialId != null &&
          multiLocationEnabled &&
          editStockRows.length
        ) {
        <div class="form-block stock-block">
          <h5>Lager pr. lokation</h5>
          @for (row of editStockRows; track row.location_id) {
          <div class="stock-row">
            <span>{{ row.name }}</span>
            <mat-form-field appearance="outline" class="inline-edit">
              <mat-label>Antal</mat-label>
              <input
                matInput
                type="number"
                min="0"
                [(ngModel)]="row.quantity"
              />
            </mat-form-field>
          </div>
          }
          <p class="form-hint">Sum: {{ stockSum() }} (opdateres som total antal)</p>
        </div>
        }
      </div>
    </mat-tab>

    <mat-tab label="Ledighed">
      <div class="tab-content">
        <div class="toolbar calendar-toolbar">
          <mat-form-field appearance="outline">
            <mat-label>Fra dato</mat-label>
            <input matInput type="date" [(ngModel)]="calendarFrom" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Til dato</mat-label>
            <input matInput type="date" [(ngModel)]="calendarTo" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Materiale (valgfri)</mat-label>
            <mat-select [(ngModel)]="calendarMaterialId">
              <mat-option [value]="null">Alle</mat-option>
              @for (m of materials; track m.material_id) {
              <mat-option [value]="m.material_id">{{ m.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <button
            mat-raised-button
            color="primary"
            (click)="loadCalendar()"
            [disabled]="calendarLoading"
          >
            {{ calendarLoading ? "Henter..." : "Vis bookinger" }}
          </button>
        </div>
        @if (calendarBookings.length) {
        <table class="requests-table">
          <thead>
            <tr>
              <th>Periode</th>
              <th>Event</th>
              <th>Materiale</th>
              <th>Antal</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            @for (b of calendarBookings; track b.event_material_id) {
            <tr>
              <td>
                {{ b.start_date | date : "shortDate" }} –
                {{ b.end_date | date : "shortDate" }}
              </td>
              <td>{{ b.event_short_name || b.event_guid }}</td>
              <td>{{ b.material_name }}</td>
              <td>{{ b.quantity }}</td>
              <td>{{ statusLabel(b.status) }}</td>
            </tr>
            }
          </tbody>
        </table>
        } @else if (!calendarLoading) {
        <p class="empty-message">
          Ingen bookinger i perioden. Vælg datoer og klik "Vis bookinger".
        </p>
        }
      </div>
    </mat-tab>

    @if (multiLocationEnabled || materialLocations.length > 0) {
    <mat-tab label="Lagerlokationer">
      <div class="tab-content">
        <div class="toolbar">
          <mat-form-field appearance="outline">
            <mat-label>Ny lokation</mat-label>
            <input matInput [(ngModel)]="newLocationName" />
          </mat-form-field>
          <button
            mat-raised-button
            color="primary"
            [disabled]="saving || !newLocationName.trim()"
            (click)="createLocation()"
          >
            Opret lokation
          </button>
        </div>
        @if (materialLocations.length) {
        <table class="requests-table location-table">
          <thead>
            <tr>
              <th>Navn</th>
              <th>Antal på lager</th>
              <th>Handlinger</th>
            </tr>
          </thead>
          <tbody>
            @for (loc of materialLocations; track loc.location_id) {
            <tr>
              <td>
                @if (editingLocationId !== loc.location_id) {
                {{ loc.name }}
                } @else {
                <mat-form-field appearance="outline" class="inline-edit">
                  <input matInput [(ngModel)]="editLocationName" />
                </mat-form-field>
                }
              </td>
              <td>{{ loc.stock_quantity ?? 0 }}</td>
              <td class="location-actions">
                @if (editingLocationId !== loc.location_id) {
                <button mat-button type="button" (click)="startEditLocation(loc)">
                  Rediger
                </button>
                <button
                  mat-button
                  type="button"
                  class="btn-remove"
                  [disabled]="!canDeleteLocation(loc) || saving"
                  [title]="
                    canDeleteLocation(loc)
                      ? 'Slet lokation'
                      : 'Kan ikke slettes mens der er materiel på lageret'
                  "
                  (click)="deleteLocation(loc)"
                >
                  Slet
                </button>
                } @else {
                <button
                  mat-button
                  type="button"
                  [disabled]="saving"
                  (click)="cancelEditLocation()"
                >
                  Annuller
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  [disabled]="saving || !editLocationName.trim()"
                  (click)="saveEditLocation()"
                >
                  Gem
                </button>
                }
              </td>
            </tr>
            }
          </tbody>
        </table>
        } @else {
        <p class="empty-message">
          Aktiver "Flere lagerlokationer" under org-indstillinger og opret lokationer her.
        </p>
        }

        <div class="notify-block">
          <h4>Notifikation ved anmodning</h4>
          <p class="notify-lead">
            Vælg hvem der får e-mail, når nogen anmoder om materiel til et event.
            Hvis ingen er valgt, sendes ingen admin-besked.
          </p>
          @if (loadingNotify || loadingOrgUsers) {
          <p class="loading-message">Henter modtagere...</p>
          } @else if (orgUsersLoadError) {
          <p class="error-message">{{ orgUsersLoadError }}</p>
          } @else if (orgUserCandidates.length) {
          <ol class="notify-steps">
            <li>
              Brug søgefeltet til at finde personer, åbn en boks og vælg dem i
              listen.
            </li>
            <li>Gentag for andre lokationer, hvis det er relevant.</li>
            <li>Klik <strong>Gem modtagere</strong> — ellers gemmes ændringerne ikke.</li>
          </ol>

          <div class="notify-fields">
            <mat-form-field appearance="outline" class="notify-field notify-user-search">
              <mat-label>Søg bruger</mat-label>
              <input
                matInput
                type="search"
                [(ngModel)]="notifyUserSearch"
                placeholder="Navn eller e-mail"
                autocomplete="off"
              />
              <mat-hint>
                Filtrerer brugerlisten i alle modtagerfelter nedenfor.
                {{ filteredNotifyUserCandidates().length }} af
                {{ orgUserCandidates.length }} vises.
              </mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="notify-field">
              <mat-label>Fælles modtagere (alle lokationer)</mat-label>
              <mat-select multiple [(ngModel)]="notifyAllUserIds">
                <mat-select-trigger>
                  {{ notifySelectedLabel(notifyAllUserIds) }}
                </mat-select-trigger>
                @for (u of filteredNotifyUserCandidates(); track u.user_id) {
                <mat-option [value]="u.user_id">
                  {{ u.name }} — {{ u.email }}
                </mat-option>
                } @empty {
                <mat-option disabled>Ingen brugere matcher søgningen</mat-option>
                }
              </mat-select>
              <mat-hint>
                Disse personer får besked ved alle nye materialanmodninger.
              </mat-hint>
            </mat-form-field>

            @if (materialLocations.length) {
            <p class="notify-section-label">Ekstra modtagere pr. lagerlokation</p>
            <p class="notify-section-hint">
              Tilføjes til fælles modtagere, når anmodningen handler om den
              lokation.
            </p>
            @for (loc of materialLocations; track loc.location_id) {
            <mat-form-field appearance="outline" class="notify-field">
              <mat-label>Lokation: {{ loc.name }}</mat-label>
              <mat-select
                multiple
                [(ngModel)]="notifyByLocationIds[loc.location_id]"
              >
                <mat-select-trigger>
                  {{
                    notifySelectedLabel(
                      notifyByLocationIds[loc.location_id]
                    )
                  }}
                </mat-select-trigger>
                @for (u of filteredNotifyUserCandidates(); track u.user_id) {
                <mat-option [value]="u.user_id">
                  {{ u.name }} — {{ u.email }}
                </mat-option>
                } @empty {
                <mat-option disabled>Ingen brugere matcher søgningen</mat-option>
                }
              </mat-select>
            </mat-form-field>
            }
            }
          </div>

          <div class="notify-actions">
            <button
              mat-raised-button
              color="primary"
              [disabled]="savingNotify"
              (click)="saveNotifyRecipients()"
            >
              {{ savingNotify ? "Gemmer..." : "Gem modtagere" }}
            </button>
          </div>
          } @else {
          <p class="form-hint">
            Ingen brugere fundet i organisationen til notifikation.
          </p>
          }
        </div>
      </div>
    </mat-tab>
    }

    <!-- Event requests tab -->
    <mat-tab label="Eventanmodninger">
      <div class="tab-content">
        @if (loadingRequests) {
        <p class="loading-message">Henter anmodninger...</p>
        } @if (!loadingRequests && eventRequests.length) {
        <mat-accordion>
          @for (ev of eventRequests; track ev) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ ev.start_date | date : "short" }} –
                {{ ev.event_short_name || "Event" }}
                @if (ev.event_org_name) {
                <span class="org-badge">({{ ev.event_org_name }})</span>
                }
              </mat-panel-title>
            </mat-expansion-panel-header>
            <table class="requests-table">
              <thead>
                <tr>
                  <th>Materiale</th>
                  <th>Antal</th>
                  <th>Ledigt</th>
                  <th>Status</th>
                  <th>Instruktørnote</th>
                  <th>Admin note</th>
                  <th>Handlinger</th>
                </tr>
              </thead>
              <tbody>
                @for (r of ev.requests; track r) {
                <tr>
                  <td>{{ r.material_name }}</td>
                  <td>{{ r.quantity }}</td>
                  <td>
                    @if (r.remaining_for_event !== undefined) {
                    {{ r.remaining_for_event }}
                    } @else {
                    -
                    }
                  </td>
                  <td>{{ statusLabel(r.status) }}</td>
                  <td class="notes-cell">{{ r.instructor_notes || "-" }}</td>
                  <td class="notes-cell">
                    <input
                      type="text"
                      [(ngModel)]="adminNotes[r.event_material_id]"
                      [placeholder]="r.admin_notes || 'Tilføj note'"
                      (blur)="
                        saveAdminNotes(
                          ev.event_guid,
                          r.event_material_id,
                          adminNotes[r.event_material_id] || ''
                        )
                      "
                    />
                  </td>
                  <td>
                    @if (r.status === 'pending') {
                    <button
                      mat-button
                      color="primary"
                      (click)="
                        approveRequest(ev.event_guid, r.event_material_id)
                      "
                      [disabled]="
                        saving ||
                        (r.remaining_for_event !== undefined &&
                          r.quantity > r.remaining_for_event)
                      "
                    >
                      Godkend
                    </button>
                    <button
                      mat-button
                      (click)="
                        rejectRequest(ev.event_guid, r.event_material_id)
                      "
                      [disabled]="saving"
                    >
                      Afvis
                    </button>
                    } @if (r.status !== 'pending') {
                    <span>{{ statusLabel(r.status) }}</span>
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </mat-expansion-panel>
          }
        </mat-accordion>
        } @if (!loadingRequests && eventRequests.length === 0) {
        <p class="empty-message">Ingen eventanmodninger med materialer.</p>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
